import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function ingredientCategoryStart({ outletIds }) {
  pushClevertapEvent('Ingredient Category Start', {
    'Current Selected Outlet': outletIds,
  });
}

export function ingredientCategoryChangeOutlet({ currentOutlet, outletIds }) {
  pushClevertapEvent('Ingredient Category Change Outlet', {
    'Previous Selected Outlet': currentOutlet,
    'Current Selected Outlet': outletIds,
  });
}

export function ingredientCategorySelect({ category }) {
  pushClevertapEvent('Ingredient Category Select', {
    Name: category.name,
  });
}

export function ingredientCategoryCreate({ category, allOutlet }) {
  let eventName;
  if (allOutlet) {
    eventName = 'Ingredient Category Create All Outlet';
  } else {
    eventName = 'Ingredient Category Create One Outlet';
  }
  pushClevertapEvent(eventName, {
    Name: category.name,
  });
}

export function ingredientCategoryDelete({ category }) {
  pushClevertapEvent('Ingredient Category Delete', {
    Name: category.name,
  });
}

export function ingredientCategoryAssign({ category, data }) {
  pushClevertapEvent('Ingredient Category Assign', {
    Name: category.name,
    'Ingredient List': data,
  });
}
